export default {"src":"/_next/static/media/chicken.71cff4bc.svg","height":152,"width":152};